import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgOrientationLandscape = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.13497 16.1058C3.32647 16.2532 3.62934 16.3699 4.0001 16.3699L20.0001 16.3699C20.3709 16.3699 20.6737 16.2532 20.8652 16.1058C21.0557 15.9591 21.1001 15.8185 21.1001 15.7299L21.1001 8.02992C21.1001 7.94134 21.0557 7.80076 20.8652 7.65407C20.6737 7.50662 20.3709 7.38992 20.0001 7.38992L4.0001 7.38992C3.62934 7.38992 3.32647 7.50662 3.13497 7.65407C2.94446 7.80076 2.9001 7.94134 2.9001 8.02992L2.9001 15.7299C2.9001 15.8185 2.94446 15.9591 3.13497 16.1058ZM4.0001 18.1699C2.6313 18.1699 1.1001 17.282 1.1001 15.7299L1.1001 8.02992C1.1001 6.47781 2.6313 5.58992 4.0001 5.58992L20.0001 5.58992C21.3689 5.58992 22.9001 6.47781 22.9001 8.02992L22.9001 15.7299C22.9001 17.282 21.3689 18.1699 20.0001 18.1699L4.0001 18.1699Z"
      fill="black"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgOrientationLandscape)
const IconSvgOrientationLandscape = createIcon(
  ForwardRef,
  'SvgOrientationLandscape',
)
export default IconSvgOrientationLandscape
